import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    usersTable: {
        filters: {
            search: '',
            code: '',
            page: 0,
            pageSize: 10,
        },
    },
    ideasTable: {
        filters: {
            search: '',
            status: '',
            tags: [],
            creator: '',
            page: 0,
            pageSize: 10,
        },
    },
    tagsTable: {
        filters: {
            search: '',
            page: 0,
            pageSize: 10,
        },
    },
    eventsTable: {
        filters: {
            page: 0,
            pageSize: 10,
        },
    },
};

const tableStatesSlice = createSlice({
    name: 'tableStates',
    initialState,
    reducers: {
        setUsersTableFilters: (state, action) => {
            state.usersTable.filters = action.payload;
        },
        setIdeasTableFilters: (state, action) => {
            state.ideasTable.filters = action.payload;
        },
        setTagsTableFilters: (state, action) => {
            state.tagsTable.filters = action.payload;
        },
        setEventsTableFilters: (state, action) => {
            if (!state.eventsTable) state.eventsTable = {};
            state.eventsTable.filters = action.payload;
        },
    },
})

export const { setUsersTableFilters, setIdeasTableFilters, setTagsTableFilters, setEventsTableFilters } = tableStatesSlice.actions;
export const selectUsersTableFilters = (state) => state.tableStates.usersTable.filters;
export const selectIdeasTableFilters = (state) => state.tableStates.ideasTable.filters;
export const selectTagsTableFilters = (state) => state.tableStates.tagsTable.filters;
export const selectEventsTableFilters = (state) => state.tableStates.eventsTable?.filters ?? { page: 0, pageSize: 10 };
export default tableStatesSlice.reducer;